import Sales from '../../services/sales';

export default {
  props: [
    'request'
  ],
  data() {
    return {
      resposta: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
      ],
      perguntaCaptcha: '',
      backgroundColorsA1: '#FFF',
      backgroundColorsA2: '#FFF',
      backgroundColorsA3: '#FFF',
      backgroundColorsB1: '#FFF',
      backgroundColorsB2: '#FFF',
      backgroundColorsB3: '#FFF',
      backgroundColorsC1: '#FFF',
      backgroundColorsC2: '#FFF',
      backgroundColorsC3: '#FFF',
      borderA1: 'none',
      borderA2: 'none',
      borderA3: 'none',
      borderB1: 'none',
      borderB2: 'none',
      borderB3: 'none',
      borderC1: 'none',
      borderC2: 'none',
      borderC3: 'none',
      tokenCaptcha: ''
    }
  },

  mounted(){
    this.getCaptcha();
    document.body.style.overflow = 'hidden';
  },
  beforeDestroy() {
    document.body.style.overflow = 'auto';
  },
  computed: {
    colorComputed () {
      return this.resposta[0] ? { 'background-color': 'red' } : { 'background-color': 'white' }
    }
  },
  methods: {
    async getCaptcha () {
      const result          = await Sales.captchaAdhesion("teste")
      this.tokenCaptcha     = result.token;
      this.perguntaCaptcha  = result.perguntaCaptcha;
      this.resposta         = [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
      ];
      $("#logoContainer").html($())
      $("#LabelA1").html($());
      $("#LabelA2").html($());
      $("#LabelA3").html($());
      $("#LabelB1").html($());
      $("#LabelB2").html($());
      $("#LabelB3").html($());
      $("#LabelC1").html($());
      $("#LabelC2").html($());
      $("#LabelC3").html($());
      this.backgroundColorsA1 = "#fff";
      this.backgroundColorsA2 = "#fff";
      this.backgroundColorsA3 = "#fff";
      this.backgroundColorsB1 = "#fff";
      this.backgroundColorsB2 = "#fff";
      this.backgroundColorsB3 = "#fff";
      this.backgroundColorsC1 = "#fff";
      this.backgroundColorsC2 = "#fff";
      this.backgroundColorsC3 = "#fff";
      this.borderA1 = '1px solid #fff';
      this.borderA2 = '1px solid #fff';
      this.borderA3 = '1px solid #fff';
      this.borderB1 = '1px solid #fff';
      this.borderB2 = '1px solid #fff';
      this.borderB3 = '1px solid #fff';
      this.borderC1 = '1px solid #fff';
      this.borderC2 = '1px solid #fff';
      this.borderC3 = '1px solid #fff';
      $("#logoContainer").append($(result.LogoMM.IMAGEM_SVG));
      $("#LabelA1").append($(result.arrayCaptcha[0].IMAGEM_SVG));
      $("#LabelA2").append($(result.arrayCaptcha[1].IMAGEM_SVG));
      $("#LabelA3").append($(result.arrayCaptcha[2].IMAGEM_SVG));
      $("#LabelB1").append($(result.arrayCaptcha[3].IMAGEM_SVG));
      $("#LabelB2").append($(result.arrayCaptcha[4].IMAGEM_SVG));
      $("#LabelB3").append($(result.arrayCaptcha[5].IMAGEM_SVG));
      $("#LabelC1").append($(result.arrayCaptcha[6].IMAGEM_SVG));
      $("#LabelC2").append($(result.arrayCaptcha[7].IMAGEM_SVG));
      $("#LabelC3").append($(result.arrayCaptcha[8].IMAGEM_SVG));
    },

    captchaSelecionado (id, name) {
      let checkbox      = this.resposta[id] ? false : true;
      this.resposta[id] = checkbox;

      if (id === 0){
        this.backgroundColorsA1 = checkbox ? '#DFC1FF' : '#fff'
        this.borderA1           = checkbox ? '1px solid #CE9FFF' : '1px solid #fff'
      }
      if (id === 1){
        this.backgroundColorsA2 = checkbox ? '#DFC1FF' : '#fff'
        this.borderA2           = checkbox ? '1px solid #CE9FFF' : '1px solid #fff'
      }
      if (id === 2){
        this.backgroundColorsA3 = checkbox ? '#DFC1FF' : '#fff'
        this.borderA3           = checkbox ? '1px solid #CE9FFF' : '1px solid #fff'
      }
      if (id === 3){
        this.backgroundColorsB1 = checkbox ? '#DFC1FF' : '#fff'
        this.borderB1           = checkbox ? '1px solid #CE9FFF' : '1px solid #fff'
      }
      if (id === 4){
        this.backgroundColorsB2 = checkbox ? '#DFC1FF' : '#fff'
        this.borderB2           = checkbox ? '1px solid #CE9FFF' : '1px solid #fff'
      }
      if (id === 5){
        this.backgroundColorsB3 = checkbox ? '#DFC1FF' : '#fff'
        this.borderB3           = checkbox ? '1px solid #CE9FFF' : '1px solid #fff'
      }
      if (id === 6){
        this.backgroundColorsC1 = checkbox ? '#DFC1FF' : '#fff'
        this.borderC1           = checkbox ? '1px solid #CE9FFF' : '1px solid #fff'
      }
      if (id === 7){
        this.backgroundColorsC2 = checkbox ? '#DFC1FF' : '#fff'
        this.borderC2           = checkbox ? '1px solid #CE9FFF' : '1px solid #fff'
      }
      if (id === 8){
        this.backgroundColorsC3 = checkbox ? '#DFC1FF' : '#fff'
        this.borderC3           = checkbox ? '1px solid #CE9FFF' : '1px solid #fff'
      }
      return;
    },

    async responderCaptcha () {
      if (this.request === "request") return;
      this.$emit('abrirLoadingV2');
      const body = { 
        resposta: this.resposta, 
        adhesion: this.request, 
        token: this.tokenCaptcha 
      }
      const resposta = await Sales.captchaAdhesionPost(body);

      if (!resposta) {
        this.$emit('fecharLoadingV2');
        return this.getCaptcha();
      }

      this.$emit('continuarCaptcha', resposta);
      this.$emit('fecharCaptcha');

    }
  }

}



// WEBPACK FOOTER //
// ./src/components/captcha/captcha.js